var parent = require('../../es/json/stringify');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/json/stringify.js
// module id = 372
// module chunks = 0 1